import { render, staticRenderFns } from "./CompetitionLogo.vue?vue&type=template&id=1d98d5c2&scoped=true"
import script from "./CompetitionLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompetitionLogo.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d98d5c2",
  null
  
)

export default component.exports